import { render } from "./OlabPlate.vue?vue&type=template&id=e226df1e&scoped=true"
import script from "./OlabPlate.vue?vue&type=script&lang=js"
export * from "./OlabPlate.vue?vue&type=script&lang=js"

import "./OlabPlate.vue?vue&type=style&index=0&id=e226df1e&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e226df1e"]])

export default __exports__